module.exports = __webpack_public_path__ + "static/media/whiskey-modal.eb7bc9d2.svg";